import Swal from 'sweetalert2';
import { NotificationManager } from 'react-notifications';
import moment from "moment";

const showMessage = (type, msg, title = null) => {
    switch (type) {
        case 'info':
            NotificationManager.info(msg, title);
            break;
        case 'success':
            NotificationManager.success(msg, title);
            break;
        case 'warning':
            NotificationManager.warning(msg, title);
            break;
        case 'error':
            NotificationManager.error(msg, title);
            break;
    }
};

const getFormFieldName = (dynamicForm) => {
    let arr = [];
    dynamicForm.forEach((formDataArr) => {
        formDataArr?.formFields.forEach((subFormData) => {
            if (subFormData?.require) {
                arr.push(subFormData?.name);
            }
        });
    });

    return arr;
};

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

function updateData(arr, id, newState) {
    // arr[id - 1] = newState;
    // return arr;
    return arr.map((item) => (item.id === id ? newState : item));
}

function deleteData(arr, id, uniqueKey) {
    return arr.filter((item) => {
        return item[uniqueKey] !== id;
    });
}


function deleteIndexData(arr, id) {
    return arr.filter((item, i) => {
        return i !== id;
    });
}

function findObj(optionList = [], accessKey, value) {
    const filterData = optionList.filter((item) => item[accessKey] === value);
    return filterData.length > 0 ? filterData[0] : ""
}

function findArrObj(arr, id) {
    return arr.filter((item) => item.id === id);
}

function findMatchingOrders(tableData, optionstate) {
    return tableData.filter(tableOrder =>
        !optionstate.some(optionOrder => optionOrder.order_no === tableOrder.order_no)
    );
}

function percentageVal(amount, percentage) {
    return (parseInt(amount) * parseInt(percentage)) / 100;
}

function ValtoPercentage(amount, percentage) {
    return (parseInt(amount) / parseInt(percentage)) * 100;
}

const dateConversion = (date, format = "DD-MM-YYYY") => {
    const result = date ? moment(date).format(format) : "";
    return result
}

const showConfirmationDialog = (
    message,
    callback,
    confirmButtonText = 'Yes',
    cancelButtonText = 'No',
    title = 'Are you sure?'
) => {
    Swal.fire({
        title: title,
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        customClass: {
            icon: 'swal-icon-custom',
        },
    }).then((result) => {
        if (result.isConfirmed) {
            callback();
        } else {
            Swal.fire({
                title: 'Cancelled!',
                text: 'Permission denied.',
                icon: 'error',
                customClass: {
                    icon: 'swal-icon-custom',
                },
                timer: 1500,
            });
        }
    });
};
//emi

const annualToMonthlyInterestRate = (annualInterest) => {
    const r = annualInterest / (12 * 100);
    return r;
};

const emiCalculation = (principal, annualInterest, tenurePeriod) => {
    const p = parseFloat(principal);
    const r = annualToMonthlyInterestRate(annualInterest);
    const t = parseInt(tenurePeriod) * 12;

    const emi = (p * r * Math.pow(1 + r, t)) / (Math.pow(1 + r, t) - 1);

    return emi;
};


const interestForMonth = (remainingPrincipal, monthlyInterestRate) => {
    const monthInterest = parseFloat(remainingPrincipal * monthlyInterestRate);
    return monthInterest;
};


const principalRepayment = (emi, monthInterest) => {
    const principalRepay = parseFloat(emi - monthInterest);
    return principalRepay;
};


const principalRemaining = (remainingPrincipal, principalRepayment) => {
    const principalRemain = parseFloat(remainingPrincipal - principalRepayment);
    return principalRemain;
};

const calculateTotalInterestPayable = (principal, annualInterest, tenurePeriod) => {
    let totalInterestPayable = 0;
    let remainingPrincipal = principal;
    const monthlyInterestRate = annualToMonthlyInterestRate(annualInterest);
    const emi = emiCalculation(principal, annualInterest, tenurePeriod);

    for (let month = 1; month <= tenurePeriod * 12; month++) {
        const monthInterestAmount = interestForMonth(remainingPrincipal, monthlyInterestRate);
        const principalRepay = principalRepayment(emi, monthInterestAmount);
        remainingPrincipal = principalRemaining(remainingPrincipal, principalRepay);

        // Accumulate the interest for the current month
        totalInterestPayable += monthInterestAmount;
    }

    return totalInterestPayable;
};

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function findObject(request) {
    const findObj = {};
    if (request.size) {
        findObj.size = request.size;
    }
    if (request.page) {
        findObj.page = request.page;
    }
    if (request.search) {
        findObj.search = request.search;
    }
    if (request.collection_day) {
        findObj.collection_day = request.collection_day;
    }
    if (request.collection_date) {
        findObj.collection_date = request.collection_date;
    }
    if (request.payment_status) {
        findObj.payment_status = request.payment_status;
    }
    if (request.from_date) {
        findObj.from_date = request.from_date;
    }
    if (request.to_date) {
        findObj.to_date = request.to_date;
    }
    if (request.user_id) {
        findObj.user_id = request.user_id;
    }
    if (request.order_id) {
        findObj.order_id = request.order_id;
    }
    if (request.landmark_id) {
        findObj.landmark_id = request.landmark_id;
    }
    if (request.area_id) {
        findObj.area_id = request.area_id;
    }
    if (request.product_id) {
        findObj.product_id = request.product_id;
    }
    if (request.order_by) {
        findObj.order_by = request.order_by;
    }
    return findObj;
}

// function getCustomDateAndFourWeeksAgo(customDateStr) {
//     const customDate = new Date(customDateStr); // Parse the custom date

//     // Calculate the date four weeks ago
//     const fourWeeksAgo = new Date(customDate);
//     fourWeeksAgo.setDate(customDate.getDate() - 28);

//     // Helper function to format the date as 'DD-MM-YYYY'
//     const formatDates = (date) => {
//         const day = String(date.getDate()).padStart(2, '0');
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const year = date.getFullYear();
//         return `${day}-${month}-${year}`;
//     };

//     return {
//         toDate: customDate, // Keep as a Date object for comparison
//         fourWeeksAgoDate: fourWeeksAgo, // Keep as a Date object for comparison
//         formattedToDate: formatDates(customDate), // Return formatted string for display
//         formattedFourWeeksAgoDate: formatDates(fourWeeksAgo) // Return formatted string for display
//     };
// }

function getCustomDateAndFourWeeksAgo(customDateStr) {
    const customDate = moment(customDateStr); // Parse the custom date
    const fourWeeksAgo = moment(customDate).subtract(28, 'days'); // 4 weeks ago

    return {
        toDate: customDate,
        fourWeeksAgoDate: fourWeeksAgo,
        formattedToDate: customDate.format('DD-MM-YYYY'),
        formattedFourWeeksAgoDate: fourWeeksAgo.format('DD-MM-YYYY'),
    };
}

export {
    showMessage,
    getFormFieldName,
    formatDate,
    showConfirmationDialog,
    updateData,
    deleteData,
    findObj,
    findArrObj,
    percentageVal,
    ValtoPercentage,
    dateConversion,
    deleteIndexData,

    emiCalculation,
    interestForMonth,
    principalRepayment,
    principalRemaining,
    annualToMonthlyInterestRate,
    calculateTotalInterestPayable,
    numberWithCommas,

    findObject,
    findMatchingOrders,
    getCustomDateAndFourWeeksAgo,

};
